// extracted by mini-css-extract-plugin
module.exports = {"projectMenuSwitch":"ProjectMenuSwitch_projectMenuSwitch__1UugZ"};